import { createClient } from "@hey-api/client-axios";

const browserFastApiClient = createClient({
  baseURL: process.env.NEXT_PUBLIC_FASTAPI_URL,
});

export default browserFastApiClient;
